import { formatDate } from './formatString';

const getDiscountTooltipText = (discountParams) => {
  if (!discountParams) {
    return '';
  }
  if (discountParams.tooltip) {
    return discountParams.tooltip;
  }
  if (discountParams.expDate) {
    return `Скидка действует до ${formatDate(discountParams.expDate)}`;
  }
  return 'Скидка действует бессрочно';
};

export { getDiscountTooltipText };
